import { EditResponsePairKey } from "@/types/hooks/useTextAreaStates"

export const EDIT_RESPONSE_PAIR_KEY: EditResponsePairKey = "response"

/**
 * Delay in milliseconds before updating the Fortune Sheet cell
 * after switching sheets. This allows the sheet activation to complete.
 */
export const SHEET_ACTIVATION_DELAY_MS = 100
